import { render, staticRenderFns } from "./hIndex.vue?vue&type=template&id=85d2e696&scoped=true"
import script from "./hIndex.vue?vue&type=script&lang=js"
export * from "./hIndex.vue?vue&type=script&lang=js"
import style0 from "./hIndex.vue?vue&type=style&index=0&id=85d2e696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d2e696",
  null
  
)

export default component.exports